export default function getValuesFromMap<TKey, TValue>(input: Map<TKey, TValue>): TValue[] {
  return Array.from(input.values());
}
